import cart from './cart';

export type TVelCustomAniKey = 'cart'
const anis = {
    cart,
};

export default anis;
